import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { GlobalStore } from 'src/app/store/global-store';
import { CreateDistributionGroupComponent } from 'src/app/features/users/components/create-distribution-group/create-distribution-group';
import { MatDialog } from '@angular/material/dialog';
import { DistributionGroup } from 'src/app/models/distribution-group.model';
import { Recipients } from 'src/app/models/recipients.model';
import { Reminder } from 'src/app/models/reminder';
import { ChooseRecipientsComponent } from 'src/app/features/users/components/choose-recipients/choose-recipients.component';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { SvgIconComponent } from 'angular-svg-icon';
import { EApprovalStatus } from 'src/app/models/approval.model';

@Component({
    selector: 'que-no-result',
    imports: [CommonModule, TranslateDirective, TranslatePipe, SvgIconComponent],
    templateUrl: './no-result.component.html',
    styleUrls: ['./no-result.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoResultComponent {
  @Input() isEmpty?: boolean;
  @Input() isData?: boolean;
  @Input() noCommentsForPage?: boolean;
  @Input() type: string = '';

  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  #globalStore = inject(GlobalStore);
  #dialog = inject(MatDialog);
  #router = inject(Router);
  isRoleAdmin$=toSignal(this.#globalStore.isRoleAdmin$);
  isApproverManager$=toSignal(this.#globalStore.isApproverManager$);
  selectedfilter$=toSignal(this.#manipulationsToolbarStore.selectedFilter$);
  pendingApprovalTab$=toSignal(this.#manipulationsToolbarStore.pendingApprovalTab$);
  afterApprovalTab$=toSignal(this.#manipulationsToolbarStore.afterApprovalTab$);
  downloadRecordsTab$=toSignal(this.#manipulationsToolbarStore.downloadRecordsTab$);
enum = EApprovalStatus
  reset() {
    this.#manipulationsToolbarStore.resetFiltersWithoutTabs();
    // this.emitEventRest.emit();
  }
  resetApprovals() {
    this.#manipulationsToolbarStore.resetFiltersWithoutStatusApproval();
  }
  create() {
    if (this.type == "group") {
      this.#dialog.open(CreateDistributionGroupComponent,
        {
          data:{isCreate:true},
          autoFocus: false,
          position: { top: '8%' },
          panelClass: 'dialog-panel'
        })
        .afterClosed().subscribe((result) => {
          if (result) {
            const [groupName, recipients, color, groupType] = result;
            if ((recipients)) {
              this.#globalStore.createDistributionGroup(
                {
                  name: groupName,
                  users: recipients,
                  color,
                  groupType
                } as DistributionGroup)
            }
          }

        })
    }
    else {
      if (this.type == "reminder" || this.isData) {
        this.#dialog.open(ChooseRecipientsComponent,
          {
            data: { name: this.#globalStore.isHeSignal$()? "שם התזכורת":"The name of the reminder", isReminder: true , isCreated:true },
            autoFocus: false,
            position: { top: '6%' },
            panelClass: 'dialog-panel'
          })
          .afterClosed().subscribe((result) => {
            if (result) {
              const [recipients, reminderForm, mailForm, event] = result;
              if ((recipients || mailForm) && event) {
                if (event == 'create') {
                  var r = recipients as Recipients;
                  this.#globalStore.createReminder(
                    {
                      id: 0, recipients: r, subject: mailForm?.subject, content: mailForm?.body,
                      startDate: reminderForm?.startDate, frequencyId: reminderForm?.frequencyId,
                      endDate: reminderForm?.endDate, isApproval: reminderForm?.isApproval,
                      hour: reminderForm?.hour
                    } as Reminder)
                }
              }
              // hourId: new FormControl<number>(23),
            }
          })
      }
      else {
        this.#router.navigate(['create/0']);
      }
    }
  }
}
